import React, { useState } from "react"

// Components
import Card from "./card"
import TabsComponent from "./tabs"

// Data
import { data } from "../../data/services"

// Assets
import BoxBG from "../../assets/boxBG.svg"

const Estimator = ({
  singleService = false,
  service = "Website_Development",
  fullyBooked = false,
  title,
}) => {
  // Toggle for section background image
  const bgImage = false

  const [activeTab, setActiveTab] = useState(service)
  const [appState, setAppState] = useState(
    data.map(section => {
      return {
        id: section.id,
        inputs: section.inputs.map(inp => ({
          id: inp.id,
          currentValue: inp.defaultValue,
        })),
      }
    })
  )

  const updateSliderValue = (cardId, sectionId, currValue) => {
    setAppState(prev => {
      const result = [...prev]

      const budgetCard = result.find(card => card.id === cardId)

      if (budgetCard) {
        const input = budgetCard.inputs.find(inp => inp.id === sectionId)

        if (input) {
          input.currentValue = Number(currValue)
        }
      }
      if (sectionId === "customWebGraphics" && currValue == 1500) {
        data.forEach(sliderItem => {
          sliderItem.inputs.forEach(input => {
            if (input.id === "animatedGraphics") {
              input.isHidden = false
            }
          })
        })
      } else if (sectionId === "customWebGraphics" && currValue == 0) {
        data.forEach(sliderItem => {
          sliderItem.inputs.forEach(input => {
            if (input.id === "animatedGraphics") {
              const totalInputs = budgetCard?.inputs.find(
                inp => inp.id === "animatedGraphics"
              )
              if (totalInputs) {
                totalInputs.currentValue = 0
              }
              input.isHidden = true
            }
          })
        })
      }

      return result
    })
  }
  return (
    <>
      {!singleService && (
        <div className="max-w-6xl px-4 pb-8 mx-auto text-white md:pb-12 lg:pb-18">
          <div className="tabs__comp">
            <TabsComponent
              sliderData={data}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>
      )}
      <div className="max-w-6xl px-4 pb-12 mx-auto text-white app__body mt-28 md:my-12 lg:my-24 md:px-8 xl:px-0">
        {singleService && (
          <h1 className="mx-auto my-8 text-2xl font-bold uppercase md:my-12 md:text-4xl siteFont">
            {title || "Price Estimator"}
          </h1>
        )}
        <div className="app__card">
          {bgImage && (
            <object type="image/svg+xml" data={BoxBG} className="bg-image">
              bg image
            </object>
          )}
          {data.map((cardData, index) => {
            const appStateSection = appState.find(
              section => section.id === cardData.id
            )
            return (
              activeTab === cardData.id && (
                <React.Fragment key={index}>
                  <div className="budget__cards">
                    {fullyBooked && (
                      <div className="booked">
                        <h2 className="text-xl font-semibold text-center md:text-4xl">
                          Sorry, we are fully booked and no longer taking on any
                          new marketing clients until 2023.
                        </h2>
                      </div>
                    )}
                    <Card
                      key={index}
                      updateSliderValue={updateSliderValue}
                      sliderItem={{
                        ...cardData,
                        inputs: cardData.inputs.map(inp => ({
                          ...inp,
                          currentValue:
                            appStateSection?.inputs.find(
                              _inp => _inp.id === inp.id
                            )?.currentValue || 0,
                        })),
                      }}
                    />
                  </div>
                </React.Fragment>
              )
            )
          })}
        </div>
      </div>
    </>
  )
}

export default Estimator
